export { ChallengeType } from '@itm/shared-frontend/lib/components/initial';
export type { LoginParams, LoginResponse } from '@itm/shared-frontend/lib/components/initial';

export type LoginUserModel = {
  email: string;
  password: string;
};

export type TwoFactorLoginUserModel = {
  email: string;
  password: string;
  code: string;
};

export type ChangeCurrentUserPassword = {
  oldPassword: string;
  newPassword: string;
};

export type AuthenticatorDetailsResponse = {
  sharedKey: string | null;
  authenticatorUri: string | null;
};

export type UserResetTokenModel = {
  email: string;
};

export type ConfirmEmailModel = {
  email: string;
  token: string;
  password: string;
};

export type ConfirmPasswordResetModel = {
  email: string;
  token: string;
  newPassword: string;
};

export type ExchangeRequest = {
  code: string;
};

export enum ProviderType {
  Azure = 'Azure',
  Okta = 'Okta',
}

export type SamlPartnerEmailDomainResponse = {
  id: string;
  domain: string | null;
  createDate: string;
};

export type SamlPartnerIdentityProviderConfigurationResponse = {
  id: string;
  samlConfigurationId: string;
  companyId: string;
  companyName: string | null;
  type: ProviderType;
  name: string | null;
  friendlyName: string | null;
  singleSignOnServiceUrl: string | null;
  singleLogoutServiceUrl: string | null;
  artifactResolutionServiceUrl: string | null;
  createdDate: string;
  updatedDate: string | null;
  updatedBy: string | null;
  certificate: string | null;
  emailDomains: SamlPartnerEmailDomainResponse[] | null;
};

export type SamlPartnerIdentityProviderConfigurationResponsePagedResponse = {
  totalCount: number;
  items: SamlPartnerIdentityProviderConfigurationResponse[] | null;
};

export type SamlLocalServiceProviderConfigurationResponse = {
  id: string;
  samlConfigurationId: string;
  name: string | null;
  description: string | null;
  assertionConsumerServiceUrl: string | null;
  singleLogoutServiceUrl: string | null;
  artifactResolutionServiceUrl: string | null;
  createDate: string;
  updateDate: string | null;
};

export type CreateSamlPartnerIdentityProviderConfigurationDto = {
  companyId: string;
  type: ProviderType;
  name: string;
  friendlyName: string;
  singleSignOnServiceUrl: string;
  singleLogoutServiceUrl: string;
  certificate: string;
  domainList?: string[];
};

export type UpdateSamlPartnerIdentityProviderConfigurationDto = {
  id: string;
  companyId: string;
  type: ProviderType;
  name?: string;
  friendlyName?: string;
  singleSignOnServiceUrl?: string;
  singleLogoutServiceUrl?: string;
  certificate?: string;
};

export type AddEmailDomainDto = {
  samlPartnerIdentityProviderConfigurationId: string;
  domain: string;
};
